<template>
  <section class="box-boloes" data-lottery="<%=lottery.slug%>" data-vue="box-boloes" :class="[{'is-loaded' : loaded }, 'lot-'+lottery.slug]">
    <div class="box-boloes__container lot-bg">
      <p class="text-center" v-if="lottery">
      Nossos bolões estatisticamente aumentam suas chances de faturar na {{lottery.name}}. Confira!
      </p>

      <div class="box-boloes__slider">

        <div class="card-bolao card-bolao--empty" v-if="!loaded">
          <div class="text-center">
            <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
            <span>Carregando...</span>
          </div>
        </div>

        <div class="card-bolao card-bolao--empty" v-if="loaded && (!products || !products.length)">
          <div class="text-center">
            <i class="fa fa-warning" aria-hidden="true"></i><br><br>
            <span>Nenhum disponível neste momento.</span>
          </div>
        </div>

        <tiny-slider v-bind="tinySliderOptions" v-if="loaded && products && products.length">
          <div v-for="(product, index) in products" :key="`card-item-${index}`">
            <card-bolao :item-data="product"></card-bolao>
          </div>
        </tiny-slider>
      </div>

      <p class="text-center text-lowercase" v-if="lottery && lottery.hasCustomGame">Ou</p>

      <div class="box-boloes__footer" v-if="lottery && lottery.hasCustomGame">
        <a v-bind:href="'/'+lottery.slug+'/monte-seu-jogo'" class="btn btn-square btn-invert text-uppercase" v-bind:class="['btn-lot-'+lottery.slug]">Monte seu próprio Jogo!</a>
      </div>

    </div>
  </section>

</template>
<style src="./BoxBoloes.scss" scoped/>
<script>
import VueTinySlider from 'vue-tiny-slider';
import getLotBySlug from '@helpers/getLotBySlug';
import CardBolao from './CardBolao.vue';
import getProductsById from '@services/inventory/getProductsById';

export default {
  props: {
    lotterySlug: {
      type: String,
      required: true
    }
  },
  components: {
    CardBolao,
    'tiny-slider': VueTinySlider
  },
  data () {
    return {
      loaded: false,
      lottery: null,
      nextDraw: null,
      products: [],
      tinySliderOptions: {
        items: 1,
        center: false,
        autoplay: false,
        edgePadding: 0,
        autoplayButtonOutput: true,
        gutter: 20,
        loop: false,
        nav: true,
        controlsText: ['', '']
      }
    }
  },
  methods: {
    fetchInfo () {
      this.loaded = false;
      const lot = getLotBySlug(this.lotterySlug);
      this.lottery = lot;

      const proms = [
        getProductsById(lot.id, {
          groupItems: false
        })
      ];

      Promise.all(proms).then((res) => {
        this.products = (res[0]?.products || []).slice(0, 5);

        this.products.forEach((a) => {
          a.lottery = this.lottery;
        });

        this.nextDraw = res[0]?.nextDraw;
        this.loaded = true;
      });
    }
  },
  created () {
    this.fetchInfo();
  }
}
</script>
